import { Model } from 'src/types'

const imageBaseUrl = '/yellstory/baseModels'
const ysrCommonObjectValue = {
  position: 'infielder',
  dominantArm: 'right'
}
const NEW_GOLD_LINE_NEXT_PRICE = 55000 // 税込
const NEW_BEST_SELECT_PRICE = 58300 // 税込
const NEW_JUNIOR_LINE_PRICE = 44000 // 税込
const brand = 'yellStory'
const NEW_GOLD_LINE_NEXT = 'newGoldLineNext'
const NEW_BEST_SELECT = 'newBestSelect'
const NEW_JUNIOR_LINE = 'newJuniorLine'

export const reinforcementLaceModel = ['2B004G', 'SS061G', 'SS016G', '3B051G', 'BS004B', 'BS061B', '2B041JI']

const imageWidth = 240
export const ysrGoldLineBaseModel: Model[] = [
  // NEW GOLD LINE NEXT
  {
    ...ysrCommonObjectValue,
    productNumber: '2B004G',
    imageUrl: `${imageBaseUrl}/2b004g.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 27.8,
    webParts: 'Yw2',
    description:
      '小ぶりなグラブになっており、ヒンジを手口部分に近くしているため小指が効きやすくなっています。横振り縦振り両タイプに万能なグラブで、指又が入っているため深くも浅くもできるグラブです。',
    series: NEW_GOLD_LINE_NEXT,
    isFingerCrotch: true,
    isUBack: false,
    price: NEW_GOLD_LINE_NEXT_PRICE,
    brand,
    imageWidth: 240,
    imageHeight: 140
  },
  {
    ...ysrCommonObjectValue,
    productNumber: '2B041G',
    imageUrl: `${imageBaseUrl}/2b041g.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 27.8,
    webParts: 'Yw4',
    description:
      'セカンドショート向けの小ぶりなグラブです。ヒンジを下げることにより小指の効きを良くしています。レギュラー巻きにしているのでしっかりと打球感を感じられるグラブになっています。',
    series: NEW_GOLD_LINE_NEXT,
    isFingerCrotch: false,
    isUBack: false,
    price: NEW_GOLD_LINE_NEXT_PRICE,
    brand,
    imageWidth,
    imageHeight: 180
  },
  {
    ...ysrCommonObjectValue,
    productNumber: 'SS061G',
    imageUrl: `${imageBaseUrl}/ss061g.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 28.3,
    webParts: 'Yw6',
    description:
      'ヒンジを手口部分に近づけた設計にしているため、小指が効きやすくなっています。グラブ自体は一般的な大きさですが、操作性、軽量感を味わえるグラブです。',
    series: NEW_GOLD_LINE_NEXT,
    isFingerCrotch: true,
    isUBack: false,
    price: NEW_GOLD_LINE_NEXT_PRICE,
    brand,
    imageWidth,
    imageHeight: 180
  },
  {
    ...ysrCommonObjectValue,
    productNumber: 'SS062G',
    imageUrl: `${imageBaseUrl}/ss062g.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 28.3,
    webParts: 'Yw9',
    description:
      'ヒンジを手口部分に近づけた設計にしているため、小指が効きやすくなっています。ピッチャーと内野の２ポジションで使える仕様になっています。球数制限のある現代野球において万能なモデルです。',
    series: NEW_GOLD_LINE_NEXT,
    isFingerCrotch: false,
    isUBack: false,
    price: NEW_GOLD_LINE_NEXT_PRICE,
    brand,
    imageWidth,
    imageHeight: 165
  },
  {
    ...ysrCommonObjectValue,
    productNumber: 'SS016G',
    imageUrl: `${imageBaseUrl}/ss016g.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 28.6,
    webParts: 'Yw7',
    description:
      '横振りタイプ。ポケット下で掴みやすくなっているグラブです。ウェブはエッジのIウェブを採用し、紐の通し方にも工夫しており破れにくく、球際では打球に負けにくいのが特徴です。',
    series: NEW_GOLD_LINE_NEXT,
    isFingerCrotch: false,
    isUBack: false,
    price: NEW_GOLD_LINE_NEXT_PRICE,
    brand,
    imageWidth,
    imageHeight: 170
  },
  {
    ...ysrCommonObjectValue,
    productNumber: '3B051G',
    imageUrl: `${imageBaseUrl}/3b051g.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 28.7,
    webParts: 'Yw5',
    description: 'Yell-storyで一番ポケットが深くしっかりと掴むことに特化したグラブ。ウェブはエッジなので球際でも抜群の安定感を得られる。',
    series: NEW_GOLD_LINE_NEXT,
    isFingerCrotch: true,
    isUBack: false,
    price: NEW_GOLD_LINE_NEXT_PRICE,
    brand,
    imageWidth,
    imageHeight: 165
  },
  // NEW BEST SELECT
  {
    ...ysrCommonObjectValue,
    productNumber: 'BS004B',
    imageUrl: `${imageBaseUrl}/bs004b.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 27.8,
    webParts: 'Yw5',
    description:
      '小さなグラブになっており、ヒンジを手口部分に近くしているため小指が効きやすくなっています。横振り縦振り両タイプに万能なグラブで、指又が入っているため深くも浅くもできるグラブです。ウェブはエッジ機能を搭載しているため球際に強い設計となっています。',
    series: NEW_BEST_SELECT,
    isFingerCrotch: true,
    isUBack: false,
    price: NEW_BEST_SELECT_PRICE,
    brand,
    imageWidth,
    imageHeight: 165
  },
  {
    ...ysrCommonObjectValue,
    productNumber: 'BS061B',
    imageUrl: `${imageBaseUrl}/bs061b.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 28.3,
    webParts: 'Yw7',
    description:
      'ヒンジを手口部分に近づけた設計にしているため、小指が効きやすくなっています。グラブ自体は一般的な大きさですが、操作性、軽量感を味わえるグラブです。ウェブはエッジ機能を搭載しているため球際に強い設計となっています。',
    series: NEW_BEST_SELECT,
    isFingerCrotch: true,
    isUBack: false,
    price: NEW_BEST_SELECT_PRICE,
    brand,
    imageWidth,
    imageHeight: 170
  },
  {
    ...ysrCommonObjectValue,
    productNumber: 'BS016B',
    imageUrl: `${imageBaseUrl}/bs016b.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 28.6,
    webParts: 'Yw17',
    description: '横振りタイプでポケット下で掴みやすくなっているグラブです。ウェブはエッジ機能を搭載しているため球際に強い設計となっています。',
    series: NEW_BEST_SELECT,
    isFingerCrotch: false,
    isUBack: false,
    price: NEW_BEST_SELECT_PRICE,
    brand,
    imageWidth,
    imageHeight: 170
  },

  // NEW JUNIOR LINE
  {
    ...ysrCommonObjectValue,
    productNumber: '2B041JI',
    imageUrl: `${imageBaseUrl}/2b041ji.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 27.8,
    webParts: 'Yw6',
    description:
      '2B041モデルを少年用に改良。バンド部分を小さくし、手の甲のフィット感を出しました。手口部分を少し狭くし、手の小さい子でも使えるようにしました。しっかり掴めるように少年用も逆巻きを採用しました。',
    series: NEW_JUNIOR_LINE,
    isFingerCrotch: false,
    isUBack: false,
    price: NEW_JUNIOR_LINE_PRICE,
    brand,
    imageWidth,
    imageHeight: 170
  },
  {
    ...ysrCommonObjectValue,
    productNumber: 'SS016JI',
    imageUrl: `${imageBaseUrl}/ss016ji.jpg`,
    position: 'infielder',
    dominantArm: 'right',
    size: 28.6,
    webParts: 'Yw9',
    description:
      'SS016モデルを少年用に改良。バンド部分を小さくし、手の甲のフィット感を出しました。手口部分を少し狭くし、手の小さい子でも使えるようにしました。Yell-story初！投手・内野手の両方で使用できるモデルを開発しました！',
    series: NEW_JUNIOR_LINE,
    isFingerCrotch: false,
    isUBack: false,
    price: NEW_JUNIOR_LINE_PRICE,
    brand,
    imageWidth,
    imageHeight: 165
  }
]
